import { render, staticRenderFns } from "./tradeLeads.vue?vue&type=template&id=04bc67a4&scoped=true&"
import script from "./tradeLeads.vue?vue&type=script&lang=js&"
export * from "./tradeLeads.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeads.vue?vue&type=style&index=0&id=04bc67a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc67a4",
  null
  
)

export default component.exports